import { FunctionComponent } from 'react';
import { Badge, Icon, Link } from '@logz-ui/styleguide';
import { GuidedWalkthroughSubject } from '@logz-pkg/enums';
import { useObservable } from '@logz-pkg/observable';
import { HeaderButton } from 'ui/components/App/Navigation/Header/Button';
import { useGuidedWalkthrough } from 'ui/state/hooks/guided-walkthrough.state.hook';
import { WalkthroughTasks } from 'ui/components/GuidedWalkthrough/Tasks';
import { orionChatStateService } from 'ui/components/OrionChat/orion-chat.state.service';

const ClipboardIconWithBadge: FunctionComponent = () => (
  <Badge variant={'danger'} subject={GuidedWalkthroughSubject.UnseenTasksBadge} size={'xxs'}>
    <Icon icon={'clipboard-regular'} size={18} color={'royalBlue.1000'} />
  </Badge>
);

export const GuidedWalkthroughBadge: FunctionComponent = () => {
  const { isDrawerOpen, setIsDrawerOpen, seenTasksIds, allTasks, doneTasksIds } = useGuidedWalkthrough();
  const isChatDrawerOpen = useObservable(orionChatStateService.isDrawerOpen);

  const progressLabel = `${allTasks?.filter(task => doneTasksIds?.includes(task.id))?.length}/${allTasks?.length}`;
  const hasUnseenTasks = !!(seenTasksIds && seenTasksIds.length < Object.keys(WalkthroughTasks)?.length);

  const handleOnClick = () => {
    if (isChatDrawerOpen) orionChatStateService.toggleDrawer(false);

    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <Link onClick={handleOnClick} subject={GuidedWalkthroughSubject.HeaderBadge}>
      <HeaderButton
        subject={GuidedWalkthroughSubject.ProgressLabel}
        active={isDrawerOpen ?? false}
        icon={
          hasUnseenTasks ? (
            <ClipboardIconWithBadge />
          ) : (
            <Icon icon={'clipboard-regular'} size={16} color={'royalBlue.1000'} />
          )
        }
        label={`Guide (${progressLabel})`}
      />
    </Link>
  );
};
